import { render } from "./AST.vue?vue&type=template&id=f50ab3be"
import script from "./AST.vue?vue&type=script&lang=js"
export * from "./AST.vue?vue&type=script&lang=js"

import exportComponent from "/home/ec2-user/c2stem-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__